<template>
  <div id="app">
    <component :is="layout" class="min-h-screen flex flex-col">
      <RouterView v-slot="{ Component }">
        <component :is="Component" :key="$route.path" class="flex-grow"></component>
      </RouterView>
    </component>
  </div>
</template>

<script>
import HeaderApp from '@/components/Header.vue'
import FooterApp from '@/components/Footer.vue'
import Cookies from 'js-cookie'
import {mapStores} from "pinia";
import {useAuthStore} from "@/stores/auth";
import {cart} from "@/modules/cart";

export default {
  name: 'App',
  components: {FooterApp, HeaderApp },
  data () {
    return {
      default_layout: 'default'
    }
  },
  computed: {
    ...mapStores(useAuthStore),
    layout () {
      return (this.$route.meta.layout || this.default_layout) + '-layout'
    }
  }, created() {
    const token = Cookies.get('token')
    const user = Cookies.get('user')

    if (token && user) {
      this.authStore.setToken(token)
      this.authStore.setUser(JSON.parse(user))
      cart.getCart()
    }
  }
}
</script>

<style>
.Toastify__progress-bar, .Toastify__progress-bar-theme--light {
  background: #F8a71f !important;
}
</style>